import type { CSSProperties, ReactNode } from 'react';
import { Store } from 'lucide-react';
import {
  KIOSK_TAG_BASE_CLASS,
  getSalesPointTagCssVars,
} from '../../domain/salesPointTagColors.js';

export interface SalesPointTagProps {
  readonly paletteIndex: number;
  readonly children: ReactNode;
  readonly className?: string;
  /** Defaults to true — matches transactions / analytics kiosk pills. */
  readonly showIcon?: boolean;
}

/**
 * Shared sales-point / kiosk color tag. Always use this instead of hand-rolled
 * inline pastel styles so light and dark themes stay consistent app-wide.
 */
export function SalesPointTag({
  paletteIndex,
  children,
  className,
  showIcon = true,
}: SalesPointTagProps) {
  const style = getSalesPointTagCssVars(paletteIndex) as CSSProperties;
  const classes = className ? `${KIOSK_TAG_BASE_CLASS} ${className}` : KIOSK_TAG_BASE_CLASS;
  return (
    <span className={classes} style={style} data-sales-point-tag="">
      {showIcon ? <Store className="h-3 w-3 shrink-0" aria-hidden strokeWidth={2} /> : null}
      <span className="min-w-0 truncate">{children}</span>
    </span>
  );
}
